export default __webpack_public_path__ + "img/headphones.c762391f.png";